import { render, staticRenderFns } from "./station.vue?vue&type=template&id=3a045066&scoped=true&"
import script from "./station.vue?vue&type=script&lang=js&"
export * from "./station.vue?vue&type=script&lang=js&"
import style0 from "./station.vue?vue&type=style&index=0&id=3a045066&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a045066",
  null
  
)

export default component.exports